import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MICROBIOLOGY_DATA_STORAGE } from '../../on-screen-results/microbiology-data/microbiology-data-storage';
import { SponsorMicrobiologyStorage } from './sponsor-microbiology-storage';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { routeData } from '../../shared/route-helpers';
import { SponsorStudySiteIdentity } from '../sites/sponsor-study-site-identity';

@Component({
    selector: 'sponsor-microbiology',
    template: require('./sponsor-microbiology.component.html'),
    styles: [require('./sponsor-microbiology.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {provide: MICROBIOLOGY_DATA_STORAGE, useClass: SponsorMicrobiologyStorage}
    ]
})
export class SponsorMicrobiologyComponent {

    public siteId$: Observable<number>;

    constructor(route: ActivatedRoute) {
        this.siteId$ = route.parent.data.pipe(
            map(d => d[routeData.selectedSiteIdentity] as SponsorStudySiteIdentity),
            map(s => s.siteId));
    }

}